<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title">{{'HISTORY_REQUEST_INFO.DETAILS' | translate}}</div>
    </div>

    <section>
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs nav-justified">
            <li [ngbNavItem]="1">
                <a ngbNavLink>Info</a>
                <ng-template ngbNavContent>
                    <section *ngIf="request">
                        <app-dynamic-form [formName]="'stagingForm'" [formData]="formData!" [form]="formData!" [disabled]="false" [customFunctions]="customFunctions" (formSubmit)="onEvent('formSubmit', $event)" (formChange)="onEvent('formChange', $event)" (formValidation)="onEvent('formValidation', $event)"
                            #dynamicForm>
                        </app-dynamic-form>
                    </section>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <a ngbNavLink>{{'HISTORY_REQUEST_INFO.REQUESTS' | translate}}</a>
                <ng-template ngbNavContent>
                    <app-request-detail [dataSource]="history$"></app-request-detail>
                </ng-template>
            </li>
            <ng-container *ngIf="checkStatusRequest">
                <li [ngbNavItem]="3">
                    <a ngbNavLink>{{'HISTORY_REQUEST_INFO.RENEWALS' | translate}}</a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="tableWFStep" [ngTemplateOutletContext]="{
                            dataSource: renewals$ | async
                         }"></ng-template>
                    </ng-template>
                </li>
                <li [ngbNavItem]="4">
                    <a ngbNavLink>{{'HISTORY_REQUEST_INFO.TRANSFERS' | translate}}</a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="tableWFStep" [ngTemplateOutletContext]="{
                            dataSource: transfers$ | async
                         }"></ng-template>
                    </ng-template>
                </li>
                <li [ngbNavItem]="5">
                    <a ngbNavLink>{{'HISTORY_REQUEST_INFO.DEPROVISIONING' | translate}}</a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="tableWFStep" [ngTemplateOutletContext]="{
                            dataSource: deprovionings$ | async
                         }"></ng-template>
                    </ng-template>
                </li>
            </ng-container>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </section>

</div>

<ng-template let-dataSource="dataSource" #tableWFStep>
    <section>
        <table mat-table [dataSource]="dataSource" class="w-100">
            <caption>Request info</caption>
            <!-- Submission Column -->
            <ng-container matColumnDef="submission">
                <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'RENEWAL_ACTION_INFO.SUBMISSION' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
            </ng-container>

            <!-- Step Column -->
            <ng-container matColumnDef="step">
                <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'RENEWAL_ACTION_INFO.STATUS' | translate}} </th>
                <td mat-cell *matCellDef="let element">
                    <app-status-indicator [status]="element.status"></app-status-indicator>
                </td>
            </ng-container>

            <!-- ResolvedAt Column -->
            <ng-container matColumnDef="resolvedAt">
                <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'HISTORY_REQUEST_INFO.RESOLVED_AT' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.resolvedAt}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
            </tr>
        </table>
    </section>
</ng-template>